import { Popup } from "semantic-ui-react";

import { DMS_MATRIX_ROW_KINDS } from "modules/DMSv3/Capabilities/components/DMSCapabilitiesTable";

import type { DMSMatrixRow } from "modules/DMSv3/Capabilities/components/DMSCapabilitiesTable";

type FieldLabelProps = {
  row: DMSMatrixRow;
};

export const FieldLabel = ({ row: { kind, label, description } }: FieldLabelProps) => {
  if (kind === DMS_MATRIX_ROW_KINDS.Spacer) return <span className="spacer-row" />;
  if (kind === DMS_MATRIX_ROW_KINDS.Category) return <span className="category-row">{label}</span>;
  if (kind === DMS_MATRIX_ROW_KINDS.Action) return <span className="action-row">{label}</span>;
  if (!description) return <span className="field-row">{label}</span>;

  return <Popup content={description} trigger={<span className="field-row">{label}</span>} />;
};
